import { styled } from '@mui/material/styles';

const StyledErrorMessage = styled('span')`
  color: var(--error-text-color);
  display: inline-block;
  font-size: 0.75rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export default StyledErrorMessage;
